
export const changeLanguage = (language) => (dispatch) => {
    console.log("action creator");
    dispatch({
        type: "CHANGE_LANGUAGE",
        payload:  language

    })
}